import BaseService from "../baseService";
class NaturezaRendimentos extends BaseService {
  constructor(id) {
    const resource = "natureza-rendimento";
    let relationship = {};
    super(id, relationship, resource);
  }
}

export default (id) => new NaturezaRendimentos(id);
